import { Role } from '@interfaces/models';

export const Roles = Object.values(Role).filter((value) => value !== Role.NO_ROLE);
export const AssignmentRoles = [Role.ADMINISTRATOR_ROLE, Role.OPERATOR_ROLE];
